
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(3(32|35|58|66)|655|747|816|821|971)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
